import React from 'react';
import { Button, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import './ScenarioCriteriaEditor.css';
import classNames from 'classnames';

interface ScenarioCriteriaEditorProps {
  criteria: string[];
  isBusy: boolean;
  onChange: (newCriteria: string[]) => void;
  disabled?: boolean;
}

const ScenarioCriteriaEditor: React.FC<ScenarioCriteriaEditorProps> = ({
  criteria,
  isBusy,
  onChange,
  disabled,
}) => {
  const handleCriterionChange = (index: number, newValue: string) => {
    const updated = [...criteria];
    updated[index] = newValue;
    onChange(updated);
  };

  const handleDelete = (index: number) => {
    const updated = [...criteria];
    updated.splice(index, 1);
    onChange(updated);
  };

  const handleAdd = () => {
    const updated = [...criteria];
    updated.push('');
    onChange(updated);
  };

  return (
    <div
      className={classNames('scenario-criteria-editor', {
        'scenario-criteria-editor--disabled': disabled,
        'scenario-criteria-editor--busy': isBusy,
      })}
    >
      <div className="criteria-list">
        {criteria.map((criterion, index) => (
          <div key={index} className="criterion-item">
            <Input
              maxLength={150}
              showCount
              style={{ marginRight: 8 }}
              disabled={isBusy || disabled}
              placeholder={`Êtes-vous propriétaire de votre logement actuel ?`}
              value={criterion}
              onChange={(e) => handleCriterionChange(index, e.target.value)}
            />
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(index)}
              disabled={isBusy || disabled}
            />
          </div>
        ))}
        <Button
          onClick={handleAdd}
          icon={<PlusOutlined />}
          disabled={isBusy || disabled}
          type="dashed"
        >
          Ajouter un critère de validation
        </Button>
      </div>
    </div>
  );
};

export default ScenarioCriteriaEditor;
